export default "<app-header-home></app-header-home>\n<app-body-home></app-body-home>\n<app-footer-home></app-footer-home>"